import { render, staticRenderFns } from "./AdminButtons.vue?vue&type=template&id=ae121eb8&scoped=true&"
import script from "./AdminButtons.vue?vue&type=script&lang=js&"
export * from "./AdminButtons.vue?vue&type=script&lang=js&"
import style0 from "./AdminButtons.vue?vue&type=style&index=0&id=ae121eb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae121eb8",
  null
  
)

export default component.exports